import { render } from "./DocumentSetChooser.vue?vue&type=template&id=57a73f96&scoped=true"
import script from "./DocumentSetChooser.vue?vue&type=script&lang=js"
export * from "./DocumentSetChooser.vue?vue&type=script&lang=js"

import "../../assets/scss/document_set_chooser.scss?vue&type=style&index=0&id=57a73f96&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57a73f96"]])

export default __exports__